import React from 'react';
import ResultCard from './ResultCard';
import { Grid, withStyles } from 'material-ui';
import 'rc-pagination/assets/index.css';
import { LinearProgress } from 'material-ui/Progress';
import InformationPanel from '../../ui/InformationPanel';
import { translate } from 'react-i18next';

const styles = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    chip: {
        margin: theme.spacing.unit,
    },
    footer: {
        margin: '0 auto'
    }
});

/**
 * Component that displays:
 *  - top bar with
 *      - total results
 *      - sorting dropdown
 *  - main content with
 *      - list of cards for each hotel result
 *      - pagination footer (should move to another place later on)
 */
class ResultsBodyContent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: this.props.loading,
            listMode: false
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {        
        this.setState({ loading: nextProps.loading, listMode: nextProps.listMode });
    }

    markAsFavorite = () => {
        this.props.onMarkAsFavorite();
    }

    loadingEvent = () => {
        this.props.onLoadingFavorite();
    }

    render() {
        const { data, requestCode, listMode } = this.props;
        return (
            <Grid container style={{ minHeight: '800px' }}>
                <Grid item className={'main'} style={{ minHeight: '800px', minWidth: '100%' }}>
                    {
                        (data && data.length > 0) ? (
                            data.map((datum, i) => {
                                if (datum && datum.rooms && datum.rooms.length && datum.rooms[0].options && datum.rooms[0].options.length) {
                                    return (
                                        <ResultCard
                                            key={i}
                                            cardPosition={i}
                                            nights={this.props.nights}
                                            onMarkAsFavorite={this.markAsFavorite}
                                            onLoading={this.loadingEvent}
                                            requestCode={requestCode}
                                            query={this.props.query}
                                            cardData={datum}
                                            totalResults={data.length}
                                            listMode={this.state.listMode}
                                        />
                                    );
                                } else {
                                    return '';
                                }
                            })
                        ) : ''
                    }
                </Grid>
            </Grid>
        );
    }
}

export default translate('translations')(withStyles(styles)(ResultsBodyContent));



// WEBPACK FOOTER //
// ./src/components/Results/ResultsBodyContent.js